import { ResetPasswordFormFields } from './ForgottenPasswordForm.types';

export const performResetPassword = async ({
  email,
}: ResetPasswordFormFields) => {
  const form = new FormData();
  form.append(
    'ctl00$ctl00$ctl00$BodyContentPlaceHolder$BodyContentPlaceHolder$MainContentPlaceHolder$EmailAddressTextBox',
    email
  );
  form.append(
    'ctl00$ctl00$ctl00$BodyContentPlaceHolder$BodyContentPlaceHolder$MainContentPlaceHolder$SendMailButton',
    'Send'
  );
  form.append('__EVENTTARGET', '');

  const options = {
    method: 'POST',
    body: form,
  };

  return fetch('/d/RequestPassword.aspx', options);
};
